window.CustomDiscounts = {
    DISCOUNTS_API: "https://banana-moon-bulk-discounts.cloudflare2338.workers.dev/",
    FETCH_ENDPOINT: "fetch",
    CREATE_ENDPOINT: "create",
    MODIFY_ENDPOINT: "modify",

    async fetchCode(code) {
        try {
            let data = await window.fetchFromWorker(this.DISCOUNTS_API, "POST", {
                discountCode: code,
                endpoint: this.FETCH_ENDPOINT
            });
            return data;
        } catch (error) {
            console.error("An error occurred:", error);
        }
    },

    async generateProportionalCode(code, fetchedCode, subtotalIncludingBD) {
        return this.postCode(code, fetchedCode, subtotalIncludingBD, this.CREATE_ENDPOINT);
    },

    async updateProportionalCode(code, fetchedCode, subtotalIncludingBD) {
        return this.postCode(code, fetchedCode, subtotalIncludingBD, this.MODIFY_ENDPOINT);
    },

    async postCode(code, fetchedCode, subtotalIncludingBD, endpoint) {
        let percentageAmount = 0;
        if (subtotalIncludingBD !== 0)
            percentageAmount = subtotalIncludingBD * fetchedCode.code.codeDiscountNodeByCode.codeDiscount.customerGets.value.percentage;

        let additionalData = {};
        if (endpoint === this.CREATE_ENDPOINT) {
            let discountCode = fetchedCode.code.codeDiscountNodeByCode.codeDiscount;

            additionalData.appliesOncePerCustomer = discountCode.appliesOncePerCustomer;
            additionalData.combinesOrder = discountCode.combinesWith.orderDiscounts;
            additionalData.combinesProduct = discountCode.combinesWith.productDiscounts;
            additionalData.combinesShipping = discountCode.combinesWith.shippingDiscounts;
            additionalData.discountClass = discountCode.discountClass;
            additionalData.startsAt = discountCode.startsAt;
            additionalData.endsAt = discountCode.endsAt;
            additionalData.recurringCycleLimit = discountCode.recurringCycleLimit;
            additionalData.summary = discountCode.summary;
            additionalData.title = discountCode.title;

            if (discountCode?.minimumRequirement?.greaterThanOrEqualToSubtotal) {
                additionalData.minimumSubtotal = true;
                additionalData.minimumSubtotalAmount = discountCode.minimumRequirement.greaterThanOrEqualToSubtotal.amount;
                additionalData.minimumSubtotalCurrency = discountCode.minimumRequirement.greaterThanOrEqualToSubtotal.currencyCode;
            } else if (discountCode?.minimumRequirement?.greaterThanOrEqualToQuantity) {
                additionalData.minimumQuantity = true;
                additionalData.minimumSubtotalQuantity = discountCode.minimumRequirement.greaterThanOrEqualToQuantity;
            }
        }

        try {
            let data = await window.fetchFromWorker(this.DISCOUNTS_API, "POST", {
                amount: percentageAmount,
                discountCode: code,
                endpoint: endpoint,
                additionalData: additionalData
            });

            return data;
        } catch (error) {
            console.error("An error occurred:", error);
            throw error;
        }
    },

    async applyCodeViaShopify(discountCode) {
        const url = `https://www.banana-moon-clothing.co.uk/discount/${discountCode}`;
    
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "text/html",
                    "Accept": "text/html"
                }
            });
    
            if (!response.ok)
                throw new Error("Network response was not ok " + response.statusText);
    
            // No useful response information, so just ensure it's there.
            await response.text();
    
            const currentCart = await window.fetchCartData(false);
    
            if (!currentCart)
                throw new Error("The discount code could not be applied. Please try again.");
    
            // Check if the discount code was applied successfully.
            const discountCodeSet = currentCart?.cart_level_discount_applications?.some(discount =>
                discount.title.toLowerCase() === discountCode.toLowerCase()
            );
    
            if (discountCodeSet)
                return "Discount code applied successfully!";
            else
                throw new Error("The discount code could not be applied. Please try again.");
        } catch (error) {
            console.error("There was a problem applying the discount code:", error);
        }
    },

    async fetchDiscountCode (discountCode) {
        const fetchedDiscountCode = await this.fetchCode(discountCode);

        if (!fetchedDiscountCode || fetchedDiscountCode.exists == false || !fetchedDiscountCode.code)
            throw new Error(`The discount code does not exist. Please try again with a different code.`);

        return fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount;
    },

    async applyDiscountCode(discountCode) {
        const fetchedDiscountCode = await this.fetchCode(discountCode);
    
        if (!fetchedDiscountCode || fetchedDiscountCode.exists == false || !fetchedDiscountCode.code)
            throw new Error(`The discount code does not exist. Please try again with a different code.`);
    
        const activeCode = fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.status === "ACTIVE" || false;
    
        if (!activeCode)
            throw new Error(`This discount code has expired. Please try again with a different code.`);
    
        if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.customerGets.value.percentage) {
            const currentCart = await window.fetchCartData(false);
    
            if (!currentCart)
                throw new Error(`The discount code could not be applied. Please try again.`);

            const appliedCodes = currentCart?.cart_level_discount_applications
                ?.map(discount => discount?.title) ?? [];

            const hasPromotionalDiscountSet = appliedCodes.some(code => code.includes("+"));

            if (hasPromotionalDiscountSet) {
                const existingOriginalCode = appliedCodes[0].split("+")[0];

                if (existingOriginalCode && discountCode.trim().toUpperCase() === existingOriginalCode.trim().toUpperCase())
                    throw new Error(`The discount code could not be applied as it is already in use.`);
            }
    
            const designDiscount = currentCart.attributes["Design Discount"] || 0;
            const cartSubtotalIncludingBD = (currentCart.items_subtotal_price - designDiscount) / 100;
    
            if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount?.minimumRequirement?.greaterThanOrEqualToSubtotal) {
                if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.amount > cartSubtotalIncludingBD) {
                    let amountLeftToSpend = parseFloat(Math.abs(fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.amount - cartSubtotalIncludingBD)).toFixed(2);
                    throw new Error(`The discount code could not be applied. Please spend ${amountLeftToSpend} ${fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.currencyCode} more for it to be eligible.`);
                }
            } else if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount?.minimumRequirement?.greaterThanOrEqualToQuantity) {
                let nonPersonalisationItems = currentCart.items.filter(item => item.product_type != "Personalisation");
                let nonPersonalisationCount = 0;
                nonPersonalisationItems.forEach(item => {
                    nonPersonalisationCount += item.quantity;
                });
    
                if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToQuantity > nonPersonalisationCount) {
                    let additionalRequiredGarments = Math.abs(fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToQuantity - nonPersonalisationCount);
                    throw new Error(`The discount code could not be applied. Please add ${additionalRequiredGarments} more garment${additionalRequiredGarments > 1 ? "s" : ""} to use it.`);
                }
            }
    
            let generatedDiscountCode = await this.generateProportionalCode(discountCode, fetchedDiscountCode, cartSubtotalIncludingBD);
    
            if (generatedDiscountCode && generatedDiscountCode.code)
                await this.applyCodeViaShopify(generatedDiscountCode.code);
        } else {
            await this.applyCodeViaShopify(discountCode);
        }
    
        return "Discount code applied successfully!";
    },
    
    // Where cartDiscountCode is the one added to cart, i.e. bm10-abcde
    async modifyCode(discountCode, cartDiscountCode, cartSubtotalIncludingBD) {
        let fetchedDiscountCode = null;

        try {
            fetchedDiscountCode = await this.fetchCode(discountCode);

            if (!fetchedDiscountCode || fetchedDiscountCode.exists == false || !fetchedDiscountCode.code)
                throw new Error(`The discount code does not exist. Please try again with a different code.`);
    
            const activeCode = fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.status === "ACTIVE" || false;
    
            if (!activeCode)
                throw new Error(`This discount code has expired. Please try again with a different code.`);
    
            const currentCart = await window.fetchCartData(false);
    
            if (!currentCart)
                throw new Error(`The discount code could not be applied. Please try again.`);
    
            if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount?.minimumRequirement?.greaterThanOrEqualToSubtotal) {
                if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.amount > cartSubtotalIncludingBD)
                    throw new Error(`The discount code could not be applied. Please spend ${fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.currencyCode}${Math.abs(fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToSubtotal.amount - cartSubtotalIncludingBD)} more for it to be eligible.`);
            } else if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount?.minimumRequirement?.greaterThanOrEqualToQuantity) {
                let nonPersonalisationItems = currentCart.items.filter(item => item.product_type != "Personalisation");
                let nonPersonalisationCount = 0;
                nonPersonalisationItems.forEach(item => {
                    nonPersonalisationCount += item.quantity;
                });
    
                if (fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToQuantity > nonPersonalisationCount) {
                    let additionalRequiredGarments = Math.abs(fetchedDiscountCode.code.codeDiscountNodeByCode.codeDiscount.minimumRequirement.greaterThanOrEqualToQuantity - nonPersonalisationCount);
                    throw new Error(`The discount code could not be applied. Please add ${additionalRequiredGarments} more garment${additionalRequiredGarments > 1 ? "s" : ""} to use it.`);
                }
            }

            return await this.updateProportionalCode(cartDiscountCode, fetchedDiscountCode, cartSubtotalIncludingBD);
        } catch (error) {
            if (error.message !== "The discount code does not exist. Please try again with a different code.")
                return await this.updateProportionalCode(cartDiscountCode, fetchedDiscountCode, 0);

            console.error(error);
        }
    },

    async removeCodeViaShopify(discountCode) {
        const url = `https://www.banana-moon-clothing.co.uk/discount/SD_CLEAR_DISCOUNT`;
    
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "text/html",
                    "Accept": "text/html"
                }
            });
    
            if (!response.ok)
                throw new Error("Network response was not ok " + response.statusText);
    
            // No useful response information, so just ensure it's there.
            await response.text();
    
            const currentCart = await window.fetchCartData(false);
    
            if (!currentCart)
                throw new Error("The discount code could not be applied. Please try again.");
    
            // Check if the discount code was applied successfully.
            const discountCodeSet = currentCart?.cart_level_discount_applications?.some(discount =>
                discount.title.toLowerCase() === discountCode.toLowerCase()
            );
    
            if (!discountCodeSet) {
                // This is an interestingly necessary step. It'll keep re-adding the code if we don't get rid of it from the app too - likely a cookie.
                window.discountOnCartProApp.removeCode(discountCode.toUpperCase());

                return "Discount code removed successfully!";
            } else {
                throw new Error("The discount code could not be removed. Please try again.");
            }
        } catch (error) {
            console.error("There was a problem applying the discount code:", error);
        }
    },

    async reloadCartDiscountSection() {
        try {
            const url = window.location.href;
    
            const response = await fetch(url);
            if (!response.ok)
                throw new Error(`Failed to load page: ${response.statusText}`);
            
            const htmlText = await response.text();
    
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
    
            const newContent = doc.querySelector("div[data-cart-wrapper] .cart-total-details");
            const currentContent = document.querySelector("div[data-cart-wrapper] .cart-total-details");
            if (newContent && currentContent)
                currentContent.innerHTML = newContent.innerHTML;
        } catch (error) {
            console.error('Error reloading and replacing content:', error);
        }
    }  
};